import formatters from 'cio/utils/errors/formatters';
import { isNone } from '@ember/utils';

export default function formatError(error, type, variant, deliveryState, fallbackText) {
  let formatter = formatters[type];

  if (isNone(formatter)) {
    throw new Error("Formatter for provided type doesn't exist");
  }

  return formatter(error, variant, deliveryState, fallbackText);
}
